export const name = 'viewerManagerActionApi' as const

export const ViewerBatchingManagerSymbol = Symbol('ViewerBatchingManager')
